import React, { useState, useEffect } from 'react';
import { SearchBox } from './../../../common/sharedComponents/SearchBox';
import { ISelectedOption } from './../../../@types/searchBox';
import { IUser, MultiUserLookupLogic } from './../../../@types/myAudit';
import { useSearchUser } from '../../../common/hooks/useSearchUser';
import { useTranslation } from 'react-i18next';
import { handleOptionClickUtil } from './../../../common/sharedComponents/SearchBox/utils';

interface ISearchBoxContainsUsers {
  callBackSelectedOptions: (selectedOptions: any) => void;
  clearFilter: boolean;
  loggedUser: IUser;
}

export function SearchBoxContainsUsers ({
  callBackSelectedOptions,
  clearFilter,
  loggedUser,
}: ISearchBoxContainsUsers) {
  const showTags: boolean = true;
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchUser();
  const [checkRadioButton, setCheckRadioButton] =
    useState<MultiUserLookupLogic>('and');

  useEffect(() => {
    setSearchText('');
    setSearchBoxOptions([]);
    setSelectedOptions([]);
    setCheckRadioButton('and');
  }, [clearFilter]);

  useEffect(() => {
    if (selectedOptions && selectedOptions.length > 0) {
      createContainsUsers();
      setSearchText('');
    }
  }, [selectedOptions, checkRadioButton]);

  function handleInputChange (value: string) {
    setSearchText(value);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function createContainsUsers () {
    const containsUserSeachValue = {
      list: selectedOptions.map((selectedOption) => selectedOption.id),
      logic: checkRadioButton,
    };
    callBackSelectedOptions(containsUserSeachValue);
  }

  function clearSearch () {
    setSearchText('');
    if (!showTags) {
      setSelectedOptions([]);
    }
  }

  function removeTag (tagIndex: number) {
    const filteredRemovedTag = selectedOptions.filter(
      (_, index) => index !== tagIndex
    );
    const containsUserSeachValue = {
      list: filteredRemovedTag.map((selectedOption) => selectedOption.id),
      logic: undefined,
    };
    setSelectedOptions(filteredRemovedTag);
    callBackSelectedOptions(containsUserSeachValue);
  }

  function handleClickRadioButton (checkedButton: MultiUserLookupLogic) {
    setCheckRadioButton(checkedButton);
  }

  return (
    <SearchBox
      handleInputChange={handleInputChange}
      searchBoxOptions={searchBoxOptions}
      handleOptionClick={handleOptionClick}
      selectedOptions={selectedOptions}
      searchTextName={searchText}
      clearSearch={clearSearch}
      placeholderText={t(
        'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
      )}
      label={t('COMMON.MY_AUDIT.LABELS.CONTAINS')}
      showTags={showTags}
      showRadioButton={true}
      radioButtonCheckedType={checkRadioButton}
      removeTag={removeTag}
      handleClickRadioButton={handleClickRadioButton}
    />
  );
}
